import TextField from '@mui/material/TextField';
import { BaseTextFieldConfig } from 'core/components/textField/BaseTextFieldConfig';
import React from 'react';

function BaseTextField({
	id,
	name,
	fullWidth = false,
	disabled = false,
	variant = BaseTextFieldConfig.defaultVariantType,
	placeholder = '',
	value,
	onChange,
	onKeyDown = null,
	inputRef = null,
	InputProps = { disableUnderline: true },
	styles = {},
	...props
}) {
	return (
		<TextField
			id={id}
			name={name}
			fullWidth={fullWidth}
			disabled={disabled}
			variant={variant}
			placeholder={placeholder}
			value={value}
			onChange={onChange}
			onKeyDown={onKeyDown}
			inputRef={inputRef}
			InputProps={InputProps}
			sx={styles}
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...props}
		/>
	);
}

export default BaseTextField;
